<div class="page">
  <supplierDB-registration-header
    [headerText]="(headerText | translate : locale.language) ?? ''"
  />
  <main>
    <div class="main-container">
      <router-outlet />
    </div>
  </main>
  <supplierDB-registration-footer />
</div>

<p-toast />
